import { useState } from 'react';

import { AssignedDutiesTable } from '@/components/PersonCard';
import { useMyAssignedDuties } from '@/lib/directory/useDirectory';

/**
 * 내 업무분장 (V599 · 사용자 지시 2026-10-30 「내 업무는 마이페이지에서 보이게」).
 *
 * <p>인사자료 › 업무분장에서 내가 담당자로 이어진 줄들이다. 읽기만 한다 — 고치는 손은 인사자료 권한에 있다.
 * 담당업무 글(위 줄)과 섞지 않는다: 그 글은 내가 쓰는 것이고, 이것은 업무분장 표에서 온다.
 */
export function MyAssignedDutiesRow() {
  const mine = useMyAssignedDuties();
  const rows = mine.data ?? [];
  // 처음엔 닫아 둔다(사용자 지시 2026-11-02: 「너무 많아서 화면 다 가려」). 제목 줄을 누르면 펼친다.
  const [open, setOpen] = useState(false);

  return (
    <div style={{ borderTop: '1px solid var(--border)', paddingTop: '12px' }} className="space-y-2">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        disabled={rows.length === 0}
        style={{ display: 'flex', alignItems: 'center', gap: '6px', background: 'none', border: 'none', padding: 0, cursor: rows.length ? 'pointer' : 'default' }}
      >
        <span style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-secondary)' }}>업무분장</span>
        <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>{rows.length}건</span>
        {rows.length > 0 && <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>{open ? '▴' : '▾'}</span>}
      </button>
      {open && rows.length > 0 && <AssignedDutiesTable rows={rows} />}
    </div>
  );
}
